"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";
import ApiRequest from "@/shared/lib/client-sdk/api-request";
import $ from "jquery";
import Vue from "vue";
import User from "@/shared/lib/client-sdk/models/user";
import Campaign from "@/shared/lib/client-sdk/models/campaign";

class Prospect extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  get relationships() {
    return {
      campaign: Campaign,
    };
  }

  static getModelClassName() {
    return "Prospect";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create prospects.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/" +
      this.id
    );
  }

  getAdminPath() {
    return "/prospects/" + this.id;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.fullName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }

  /**** HELPER ADDITIONS ********/

  get fullName() {
    return `${this.firstName ? this.firstName + " " : ""}${this.lastName}`;
  }

  // Treat preApproved (auto-approval via RIA's skipAdvisorApproval) the same as approved
  // for downstream UI logic (transfer step, status chip, completion checks).
  get isApproved() {
    return (
      this.advisorApprovalStatus === "approved" ||
      this.advisorApprovalStatus === "preApproved"
    );
  }

  static confirmIdentity(data, callback) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/authenticated-account-holder-user/confirm-identity";

    ApiRequest.send("POST", requestUrl, data).onComplete(function (response) {
      if ($.isFunction(callback)) {
        callback(
          response.successful ? response.result : null,
          response.successful ? null : response
        );
      }
    });
  }

  static verifyEmailAddress(newEmailAddress, oldEmailAddress, callback) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/authenticated-account-holder-user/verify-email-address";

    newEmailAddress = newEmailAddress.trim();

    var requestData = {
      newEmailAddress,
      oldEmailAddress,
    };

    ApiRequest.send("POST", requestUrl, requestData).onComplete(
      function (response) {
        if (response.successful) {
          if ($.isFunction(callback))
            callback(response.result, response.message, null);
        } else {
          if ($.isFunction(callback))
            callback(null, response.message, response);
        }
      }.bind(this)
    );
  }

  static changeEmailAddress(
    newEmailAddress,
    changeEmailAddressToken,
    callback
  ) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/authenticated-account-holder-user/change-email-address";

    var requestData = {
      newEmailAddress,
      changeEmailAddressToken,
    };

    ApiRequest.send("POST", requestUrl, requestData).onComplete(
      function (response) {
        if (response.successful) {
          if ($.isFunction(callback))
            callback(response.result, response.message, null);
        } else {
          if ($.isFunction(callback))
            callback(null, response.message, response);
        }
      }.bind(this)
    );
  }

  static confirmChangeEmailAddressByCode(
    userName,
    emailConfirmationCode,
    callback
  ) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/authenticated-account-holder-user/confirm-change-email-address-by-code";

    var requestData = {
      userName: userName,
      emailConfirmationCode: emailConfirmationCode,
    };

    ApiRequest.send("POST", requestUrl, requestData).onComplete(
      function (response) {
        if (response.successful) {
          if (response.result.authentication) {
            const authToken = response.result.authentication.token;

            Vue.$cookies.set(
              "authToken",
              authToken,
              Infinity,
              "/",
              window.amplifyRuntimeConfig.get("VUE_APP_AMPLIFY_COOKIE_DOMAIN")
            );
          }

          const user = new User(response.result.user);

          if ($.isFunction(callback)) callback(user, null);
        } else {
          if ($.isFunction(callback)) callback(null, response);
        }
      }.bind(this)
    );
  }

  static checkProspect(emailAddress) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/check-invite";

    var requestBody = {
      emailAddress: emailAddress,
    };

    return new Promise((resolve, reject) => {
      ApiRequest.send(
        "POST",
        requestUrl,
        JSON.stringify(requestBody)
      ).onComplete(
        function (response) {
          if (response.successful) {
            const inviteExists = response.result?.result ?? false;
            resolve(inviteExists);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static getProspectEmailAddressByUuid(prospectUuid) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/" +
      prospectUuid +
      "/email-address";

    return new Promise((resolve, reject) => {
      ApiRequest.send("GET", requestUrl).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static registerInvitedProspect(emailAddress, password, prospectUuid = null) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/register-invited";
    var requestBody = {
      emailAddress,
      password,
      prospectUuid,
    };
    return new Promise((resolve, reject) => {
      ApiRequest.send("POST", requestUrl, requestBody).onComplete(
        function (response) {
          if (response.successful) {
            const authToken = response.result.authentication.token;

            Vue.$cookies.set(
              "authToken",
              authToken,
              Infinity,
              "/",
              window.amplifyRuntimeConfig.get("VUE_APP_AMPLIFY_COOKIE_DOMAIN")
            );

            const user = new User(response.result.user);

            window.authenticatedUser = user;
            resolve(user);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static subscriptionAction(id, subscriptionAction) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      `/public/prospects/${id}/subscription/${subscriptionAction}`;

    return new Promise((resolve, reject) => {
      ApiRequest.send("POST", requestUrl).onComplete(
        function (response) {
          if (response.successful) {
            const unsubscribed = response.result;
            resolve(unsubscribed);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static storeFile(file, type) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/stored-file/" +
      type;

    let formData = new FormData();
    formData.append("file", file);

    return new Promise((resolve, reject) => {
      ApiRequest.upload(requestUrl, formData).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static getStoredFile(id) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/stored-file/" +
      id;

    return new Promise((resolve, reject) => {
      ApiRequest.send("GET", requestUrl, null).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  static getPhotoIdPreview(side) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/photo-id/" +
      side +
      "/preview";

    return new Promise((resolve, reject) => {
      ApiRequest.send("GET", requestUrl, null).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  advisorApprovalAction(action, file) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/" +
      this.id +
      "/advisor-approval/" +
      action;

    let formData = new FormData();
    formData.append("file", file);

    return new Promise((resolve, reject) => {
      ApiRequest.upload(requestUrl, formData).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  submitApplication(callback) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/" +
      this.id +
      "/submit-application";
    return new Promise((resolve, reject) => {
      ApiRequest.send("POST", requestUrl, null).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }

  sendPreferencesCompletedNotification() {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/prospects/" +
      this.id +
      "/preferences-completed";
    return new Promise((resolve, reject) => {
      ApiRequest.send("POST", requestUrl, null).onComplete(
        function (response) {
          if (response.successful) {
            resolve(response.result);
          } else {
            reject(response);
          }
        }.bind(this)
      );
    });
  }
}

export default Prospect;
